function handleMobileMenu() {
  const breakpoint = window.matchMedia('(max-width: 1279px)');
  const btnHamburger = document.querySelector('#btn-hamburger');
  const mainMenuMobile = document.querySelector('#navbar-mobile');
  const mainMenuMobileWrapper = document.querySelector('.mobile-main-menu');
  const openSubMenuButtons = document.querySelectorAll('.mobile-main-menu .mega-menu-item.has-children > .mega-menu-item-link[level="1"]');
  const subMenus = document.querySelectorAll('.mobile-main-menu .mega-menu__submenu');
  const menuBackButtons = document.querySelectorAll('.mobile-main-menu .submenu-back-button button');
  const btnClose = document.querySelector('#btn-close-menu');
  const searchBlock = mainMenuMobile.querySelector('.header-search-block');
  const btnToggleSearch = document.querySelector('#btn-search-toggle-mobile');
  const siteHeader = document.querySelector('.site-header');
  const darkOverlay = document.querySelector('.dark-overlay');

  // Init ARIA on mobile submenu triggers
  openSubMenuButtons.forEach((button) => {
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-haspopup', 'true');
  });

  function setInert(active) {
    // Walk from #navbar-mobile up to <body>, setting inert on all siblings
    // at each level. This keeps the mobile menu interactive while blocking
    // everything else on the page.
    let current = mainMenuMobile;
    while (current && current !== document.body) {
      const parent = current.parentElement;
      if (parent) {
        for (const sibling of parent.children) {
          if (sibling !== current) {
            if (active) {
              sibling.inert = true;
            } else {
              sibling.removeAttribute('inert');
            }
          }
        }
      }
      current = parent;
    }
  }

  function reset() {
    if (subMenus.length > 0) {
      subMenus.forEach((submenu) => submenu.classList.remove('active'));
    }

    if (searchBlock) {
      searchBlock.classList.remove('active');
    }

    // Hide mobile search wrapper
    document.querySelector('.mobile-search-wrapper')?.classList.remove('active');

    // Restore switch-to section visibility
    document.querySelector('.mobile-switch-to')?.classList.remove('is-hidden');

    document.body.classList.remove('menu-open');

    // Remove inert from all body children
    setInert(false);
    document.querySelector('.mobile-main-menu-wrapper')?.removeAttribute('inert');

    // Reset aria-expanded on hamburger and search toggle
    btnHamburger?.setAttribute('aria-expanded', 'false');
    btnToggleSearch?.setAttribute('aria-expanded', 'false');

    // Reset aria-expanded on all submenu triggers
    openSubMenuButtons.forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });

    // Return focus to hamburger
    btnHamburger?.focus();
  }

  if (siteHeader && mainMenuMobileWrapper) {
    const headerHeight = siteHeader.offsetHeight || 165;
    mainMenuMobileWrapper.style.setProperty('--header-height', `${headerHeight}px`);
  }

  if (btnHamburger && mainMenuMobile) {
    btnHamburger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (searchBlock) {
        searchBlock.classList.remove('active');
      }

      document.body.classList.add('menu-open');

      // Set inert on all body children except mobile menu
      setInert(true);

      // Update aria-expanded
      btnHamburger.setAttribute('aria-expanded', 'true');

      // Focus close button
      btnClose?.focus();
    });
  }

  if (openSubMenuButtons.length > 0) {
    openSubMenuButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const parentItem = button.closest(`li.mega-menu-item`);
        const activeSubmenu = parentItem.querySelector(`.mega-menu__submenu`);

        if (activeSubmenu && mainMenuMobile) {
          const mainMenuHeight = mainMenuMobile.offsetHeight;

          const headerHeight = siteHeader ? siteHeader.offsetHeight : 0;
          const submenuHeight = mainMenuHeight - headerHeight;

          activeSubmenu.style.maxHeight = `${submenuHeight}px`;
          activeSubmenu.classList.add('active');

          document.querySelector('.navbar-mobile-wrapper').style.overflow = 'hidden';

          // Hide switch-to section when submenu is open
          document.querySelector('.mobile-switch-to')?.classList.add('is-hidden');

          // Update aria-expanded on trigger
          button.setAttribute('aria-expanded', 'true');

          // Focus the back button inside the submenu
          const backButton = activeSubmenu.querySelector('.submenu-back-button button');
          backButton?.focus();
        }
      });
    });
  }

  if (btnToggleSearch && searchBlock) {
    btnToggleSearch.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      searchBlock.classList.add('active');
      document.body.classList.add('menu-open');
      setInert(true);

      // Update aria-expanded
      btnToggleSearch.setAttribute('aria-expanded', 'true');

      const searchInput = searchBlock.querySelector('input');
      const menuContentWrapper = document.querySelector('.mobile-main-menu-wrapper');

      if (menuContentWrapper) {
        menuContentWrapper.inert = true;
      }

      if (searchInput) {
        setTimeout(() => {
          searchInput.focus({ preventScroll: true });
        }, 50);
      }
    });
  }

  // Brand switcher search button (mobile top header) opens mobile menu with search active
  const btnSearchTopHeader = document.querySelector('#btn-search-toggle-topheader');
  const mobileSearchWrapper = document.querySelector('.mobile-search-wrapper');
  if (btnSearchTopHeader && searchBlock) {
    btnSearchTopHeader.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      // Open the mobile menu panel
      document.body.classList.add('menu-open');
      setInert(true);

      // Show search wrapper and activate search block
      if (mobileSearchWrapper) {
        mobileSearchWrapper.classList.add('active');
      }
      searchBlock.classList.add('active');

      // Hide menu content
      const menuContentWrapper = document.querySelector('.mobile-main-menu-wrapper');
      if (menuContentWrapper) {
        menuContentWrapper.inert = true;
      }

      // Focus search input
      const searchInput = searchBlock.querySelector('input');
      if (searchInput) {
        setTimeout(() => {
          searchInput.focus({ preventScroll: true });
        }, 50);
      }
    });
  }

  btnClose?.addEventListener('click', () => {
    reset();
  });

  if (breakpoint?.addEventListener) {
    breakpoint.addEventListener('change', () => {
      reset();
    });
  } else {
    breakpoint.addListener(reset);
  }

  if (menuBackButtons.length > 0) {
    menuBackButtons.forEach((backButton) => {
      backButton.addEventListener('click', (e) => {
        e.preventDefault();
        const activeSubmenu = backButton.closest('.mega-menu__submenu');
        if (activeSubmenu) {
          activeSubmenu.classList.remove('active');
          document.querySelector('.navbar-mobile-wrapper').style.overflow = 'auto';

          // Show switch-to section again
          document.querySelector('.mobile-switch-to')?.classList.remove('is-hidden');

          // Find the trigger link for this submenu and reset aria-expanded
          const parentLi = activeSubmenu.closest('li.mega-menu-item.has-children');
          const triggerLink = parentLi?.querySelector(':scope > .mega-menu-item-link[level="1"]');
          triggerLink?.setAttribute('aria-expanded', 'false');

          // Return focus to the trigger link
          triggerLink?.focus();
        }
      });
    });
  }

  // Trap focus within mobile menu when open
  document.addEventListener('focusin', (e) => {
    if (!breakpoint.matches) return;
    if (!document.body.classList.contains('menu-open')) return;
    if (mainMenuMobile.contains(e.target)) return;
    btnClose?.focus();
  });

  // Escape key closes mobile menu
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && breakpoint.matches && document.body.classList.contains('menu-open')) {
      reset();
    }
  });

  darkOverlay?.addEventListener('click', () => {
    reset();
  });
}

function handleDesktopMenu() {
  const breakpoint = window.matchMedia('(min-width: 1280px)');
  const mainMenu = document.querySelector('#block-ironbark-megamenublock');
  const levelOneMenuItems = document.querySelectorAll('.main-header-desktop .mega-menu-item.has-children[level="1"] > a');
  const subMenuItems = document.querySelectorAll('.main-header-desktop .mega-menu__submenu-wrapper');
  const closeSubMenuButtons = document.querySelectorAll('.main-header-desktop .btn-close-submenu');
  const darkOverlay = document.querySelector('.dark-overlay');
  const btnToggleSearchDesktop = document.querySelectorAll('.btn-search-toggle-desktop');
  const btnCloseSearch = document.querySelector('#btn-close-search-block');
  const searchBlock = document.querySelector('.header-search-block');

  const siteHeader = document.querySelector('.site-header');

  function setDesktopInert(active) {
    // Walk from .site-header up to <body>, setting inert on all siblings.
    // Keeps the entire header interactive (nav, submenus, search, close buttons)
    // while blocking page content and footer.
    let current = siteHeader;
    while (current && current !== document.body) {
      const parent = current.parentElement;
      if (parent) {
        for (const sibling of parent.children) {
          if (sibling !== current) {
            if (active) {
              sibling.inert = true;
            } else {
              sibling.removeAttribute('inert');
            }
          }
        }
      }
      current = parent;
    }
  }

  // Init ARIA on desktop search toggle
  btnToggleSearchDesktop.forEach((button) => {
    button.setAttribute('aria-expanded', 'false');
  });

  if (levelOneMenuItems.length > 0) {
    // Init ARIA on desktop level-1 items
    levelOneMenuItems.forEach((item) => {
      item.setAttribute('aria-expanded', 'false');
      item.setAttribute('aria-haspopup', 'true');
    });

    levelOneMenuItems.forEach((menuItem) => {
      menuItem.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();

        if (menuItem.classList.contains('active')) {
          resetDesktopMenu();
        } else {
          openSubMenu(menuItem);
        }
      });
    });
  }

  function openSubMenu(menuItem) {
    const subMenu = menuItem.nextElementSibling;
    if (subMenu) {
      document.body.classList.add('menu-open');
      setDesktopInert(true);
      levelOneMenuItems.forEach((item) => {
        item.classList.remove('active');
        item.setAttribute('aria-expanded', 'false');
      });
      subMenuItems.forEach((item) => item.classList.remove('active'));
      subMenu.classList.add('active');
      menuItem.classList.add('active');
      menuItem.setAttribute('aria-expanded', 'true');

      if (searchBlock && btnToggleSearchDesktop.length > 0) {
        searchBlock.classList.remove('active');
        btnToggleSearchDesktop.forEach((button) => {
          button.classList.remove('active');
          button.setAttribute('aria-expanded', 'false');
        });
      }

      // Focus first focusable element in submenu
      setTimeout(() => {
        const focusable = subMenu.querySelector('a, button, input, [tabindex]:not([tabindex="-1"])');
        focusable?.focus();
      }, 0);
    }
  }

  if (btnToggleSearchDesktop.length > 0 && searchBlock && btnCloseSearch) {
    btnToggleSearchDesktop.forEach((button) => {
      button.addEventListener('click', (e) => {
        // Check if search block is already open
        if (searchBlock.classList.contains('active')) {
          btnCloseSearch.click();
        } else {
          e.stopPropagation();
          e.preventDefault();
          levelOneMenuItems.forEach((item) => {
            item.classList.remove('active');
            item.setAttribute('aria-expanded', 'false');
          });
          subMenuItems.forEach((item) => item.classList.remove('active'));
          searchBlock.classList.add('active');
          document.body.classList.add('menu-open');
          setDesktopInert(true);
          btnToggleSearchDesktop.forEach((btn) => {
            btn.classList.add('active');
            btn.setAttribute('aria-expanded', 'true');
            btn.setAttribute('tabindex', '-1');
          });

          const searchInput = searchBlock.querySelector('input');
          searchInput.focus();
        }
      });
    });

    btnCloseSearch.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      searchBlock.classList.remove('active');
      document.body.classList.remove('menu-open');
      setDesktopInert(false);
      btnToggleSearchDesktop.forEach((button) => {
        button.classList.remove('active');
        button.setAttribute('aria-expanded', 'false');
        button.removeAttribute('tabindex');
      });
    });
  }

  function resetDesktopMenu() {
    document.body.classList.remove('menu-open');
    setDesktopInert(false);
    levelOneMenuItems.forEach((item) => {
      item.classList.remove('active');
      item.setAttribute('aria-expanded', 'false');
    });
    subMenuItems.forEach((item) => item.classList.remove('active'));
    if (searchBlock) {
      searchBlock.classList.remove('active');
    }

    if (btnToggleSearchDesktop.length > 0) {
      btnToggleSearchDesktop.forEach((button) => {
        button.classList.remove('active');
        button.setAttribute('aria-expanded', 'false');
        button.removeAttribute('tabindex');
      });
    }

    if (mainMenu) {
      mainMenu.classList.remove('is-hidden');
    }
  }

  closeSubMenuButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.stopPropagation();
      resetDesktopMenu();
    });
  });

  // Close menu/search when clicking on header (but not on interactive elements)
  if (siteHeader) {
    siteHeader.addEventListener('click', (e) => {
      if (searchBlock?.classList.contains('active')) return;
      if (!breakpoint.matches) return;

      const isMenuOpen = document.body.classList.contains('menu-open');
      const isSearchOpen = searchBlock?.classList.contains('active');

      if (!isMenuOpen && !isSearchOpen) return;

      const isInteractive = e.target.closest('a, button, input, select, textarea');

      if (!isInteractive) {
        resetDesktopMenu();
      }
    });
  }

  if (breakpoint?.addEventListener) {
    breakpoint.addEventListener('change', () => {
      resetDesktopMenu();
    });
  } else {
    breakpoint.addListener(resetDesktopMenu);
  }

  darkOverlay.addEventListener('click', () => {
    resetDesktopMenu();
  });

  window.addEventListener('keyup', (e) => {
    if (e.key == 'Escape') {
      resetDesktopMenu();
    }
  });
}

function handleStickyHeader() {
  const siteHeader = document.querySelector('.site-header');
  const topHeader = document.querySelector('.top-header');

  if (!siteHeader) return;

  // Function to calculate and set the sticky header offset
  const setStickyHeaderOffset = () => {
    const topHeaderHeight = topHeader.getBoundingClientRect().height;
    siteHeader.style.setProperty('--sticky-header-offset', `${-topHeaderHeight}px`);
  };

  setStickyHeaderOffset();

  window.addEventListener('load', setStickyHeaderOffset);

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(setStickyHeaderOffset, 250);
  });

  const sentinel = document.querySelector('#trigger-sticky-menu');
  if (!sentinel) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        siteHeader.classList.remove('is-sticky');
      } else {
        siteHeader.classList.add('is-sticky');
      }
    },
    {
      threshold: 0,
      rootMargin: '0px',
    },
  );

  observer.observe(sentinel);
}

function handleTopHeaderMobile() {
  const toggle = document.querySelector('.brand-switcher-toggle');
  const dropdown = document.querySelector('#brand-switcher-dropdown');
  const label = document.querySelector('.brand-switcher-label');

  if (!toggle || !dropdown) return;

  // Detect active brand from body classes and update label + active state
  const body = document.body;
  const brandLinks = dropdown.querySelectorAll('a');
  let activeBrandClass = 'ironbark-financial-group';

  if (body.classList.contains('path-alias-advice')) {
    activeBrandClass = 'ironbark-advice';
  } else if (body.classList.contains('path-alias-private-wealth')) {
    activeBrandClass = 'ironbark-private-wealth';
  } else if (body.classList.contains('path-alias-investment-solutions')) {
    activeBrandClass = 'ironbark-investment-solutions';
  }

  brandLinks.forEach((link) => {
    link.classList.remove('is-active');
    if (link.classList.contains(activeBrandClass)) {
      link.classList.add('is-active');
      // Update the toggle label to show current brand name
      if (label) {
        label.textContent = link.textContent.trim();
      }
    }
  });

  function openDropdown() {
    dropdown.classList.add('active');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('brand-switcher-open');
  }

  function closeDropdown() {
    dropdown.classList.remove('active');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('brand-switcher-open');
  }

  toggle.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (dropdown.classList.contains('active')) {
      closeDropdown();
    } else {
      openDropdown();
    }
  });

  // Close on outside click
  document.addEventListener('click', (e) => {
    if (!toggle.contains(e.target) && !dropdown.contains(e.target)) {
      closeDropdown();
    }
  });

  // Close on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && dropdown.classList.contains('active')) {
      closeDropdown();
      toggle.focus();
    }
  });

}

window.addEventListener('DOMContentLoaded', () => {
  handleMobileMenu();
  handleDesktopMenu();
  handleStickyHeader();
  handleTopHeaderMobile();
});
